import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/times.svg")